import mapValues from 'lodash/mapValues';
import some from 'lodash/some';
import React from 'react';
import { context as contextReference } from './context';
import { useField } from './useField';
export function connectField(Component, options) {
    function Field(props) {
        const [fieldProps, context] = useField(props.name, props, options);
        const hasChainName = props.name !== '';
        const anyFlowingPropertySet = some(context.state, 
        // @ts-ignore: `props` has no index signature.
        (_, key) => props[key] !== null && props[key] !== undefined);
        if (!anyFlowingPropertySet && !hasChainName) {
            return React.createElement(Component, Object.assign({}, props, fieldProps));
        }
        const nextContext = Object.assign({}, context);
        if (anyFlowingPropertySet) {
            nextContext.state = mapValues(nextContext.state, (value, key) => 
            // @ts-ignore: `props` has no index signature.
            props[key] !== null && props[key] !== undefined ? !!props[key] : value);
        }
        if (hasChainName) {
            nextContext.name = nextContext.name.concat(props.name);
        }
        return (React.createElement(contextReference.Provider, { value: nextContext },
            React.createElement(Component, Object.assign({}, props, fieldProps))));
    }
    Field.displayName = `${Component.displayName || Component.name}Field`;
    return Object.assign(Field, {
        Component,
        options,
    });
}
